// @ts-nocheck: converted from JS

import { useEffect, useState } from 'react';
import { ApiService } from '@/support/ApiService';

const useCredentials = () => {
  const [loading, setLoading] = useState(true);
  const [credentials, setCredentials] = useState([]);

  useEffect(() => {
    fetchCredentials();
  }, []);

  const setNotLoading = () => setLoading(false);

  const fetchCredentials = () => {
    setLoading(true);
    return ApiService.call({
      endpoint: 'GET /api/v1/credentials',
      options: { onError: { throw: false, slug: 'team-credentials-list' } },
    })
      .then((response) => {
        if (Array.isArray(response.body?.data)) {
          setCredentials(response.body.data);
        }
      })
      .finally(setNotLoading);
  };

  const addApiKey = ({ name, scopes }) => {
    setLoading(true);
    return ApiService.call({
      endpoint: 'POST /api/v1/credentials',
      body: { name, scope: scopes },
      options: { onError: { slug: 'team-credentials-create' } },
    }).finally(setNotLoading);
  };

  const revokeApiKey = (clientId) => {
    setLoading(true);
    return ApiService.call({
      endpoint: 'DELETE /api/v1/credentials/{credentialId}',
      path: { credentialId: clientId },
      options: { onError: { slug: 'team-credentials-revoke' } },
    }).finally(setNotLoading);
  };

  return {
    credentials,
    loading,
    refetch: fetchCredentials,
    revokeApiKey,
    addApiKey,
  };
};

export default useCredentials;
